module.exports = __webpack_public_path__ + "site/img/69.bcf30c82.jpg";